import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import React from 'react'
import Theme from 'core/themes/model'

export default function CardFooter({ children, className = undefined }) {
  const classes = useStyles()
  return <footer className={clsx('card-footer', classes.footer, className)}>{children}</footer>
}

const useStyles = makeStyles<Theme>((theme) => ({
  footer: {
    padding: '8px 24px',
  },
}))
